import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { verifyEmail, afterEmailLogin, markAsVerified, finishEmailChange } from '../../../actions/user';

//import { Firebase, FirebaseRef } from '../../../lib/firebase';
import { auth, firestore } from '../../../lib/firebase';

class EmailVerifyUpdate extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }
  // static defaultProps = {}

  constructor(props) {
    super(props);
    this.state = {
      mode: null,
      lang: 'en',
      newPassword: '',
      uid: '',
      customToken: '',
      actionCode: '',
    };
  }

  componentDidMount () {
    const { logout } = this.props;
    const { search } = window.location;

      let mode;
      let actionCode;
      let continueUrl;
      let lang;
      let uid;
      let customToken;

      try {
        const urlParams = new URLSearchParams(search);
        mode = urlParams.get('mode');
        actionCode = urlParams.get('oobCode');
        continueUrl = urlParams.get('continueUrl');
        lang = urlParams.get('lang') || 'en';
        uid = urlParams.get('uid') || '';
        customToken= urlParams.get('customToken') || '';
      } catch (err) {
        mode = this.getParameterByName('mode');
        actionCode = this.getParameterByName('oobCode');
        continueUrl = this.getParameterByName('continueUrl');
        lang = this.getParameterByName('lang') || 'en';
        uid = '';
        customToken = '';
      }

    this.setState({ mode, actionCode, lang, uid, customToken });

    this.handleVerifyEmail(actionCode, continueUrl, lang, uid, customToken);
  }

  handleVerifyEmail = (actionCode, continueUrl, lang, uid, customToken) => {
    const { history, finishEmailChangeFunc, markVerified } = this.props;
    // Localize the UI to the selected language as determined by the lang
    // parameter.
    // Try to apply the email verification code.
  //  auth.applyActionCode(actionCode).then(async (resp) => {
      // Email address has been verified.
   //   console.log('resp', resp);

      // await markVerified(uid);

    finishEmailChangeFunc(customToken).then((res) => {
      this.setState({ success: true });
    }).catch((err) => {
      this.setState({ success: false, error: err || '' });
    });

    //  auth.signInWithCustomToken(customToken);

      //TO DO Change user email

    //  setTimeout(() => {
    //  const usersRef = firestore.collection('users').doc(uid);

    //  await usersRef.update({
    //    email: uid,
    //  });
    //    history.push('/email-verify-success');
        // afterLogin();
    //  }, 1000);



      // TODO: Display a confirmation message to the user.
      // You could also provide the user with a link back to the app.

      // TODO: If a continue URL is available, display a button which on
      // click redirects the user back to the app via continueUrl with
      // additional state determined from that URL's parameters.
  //  }).catch(function(error) {
   //    console.log(error);
      // Code is invalid or expired. Ask the user to verify their email address
      // again.
 //   });
  }

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    this.setState({
      [event.target.name]: value,
    });
  }

  render() {
    const { member } = this.props;
    const { mode, success, error } = this.state;

    if (mode === 'verifyEmail') {
      return (
        <div style={{ position: 'relative', textAlign: 'center', color: '#000' }}>
          Email verified successfully.
        </div>
      );
    }

    if (member && member.uid) {
      if (success) {
        return (
          <div style={{ position: 'relative', textAlign: 'center', color: '#000' }}>
            Email verified successfully.
          </div>
        );
      }

      return (
        <div style={{ position: 'relative', textAlign: 'center', color: '#000' }}>
          Failed to verify email. {error || ''}
        </div>
      );
    }

    if (success) {
      return (
        <div style={{ position: 'relative', textAlign: 'center', color: '#000' }}>
          Email verified successfully. Please login again to continue.
        </div>
      );
    }

    return (
      <div style={{ position: 'relative', textAlign: 'center', color: '#000' }}>
        Please login to your account and reopen the link to verify.
      </div>
    );

    return null;
  }
}

const mapStateToProps = state => ({
  member: state.user.userData || {},
});

const mapDispatchToProps = {
  finishEmailChangeFunc: finishEmailChange,
  markVerified: markAsVerified,
 // setVerified: setVerifiedEmail,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailVerifyUpdate));
